import { retrieveJsonRequest } from "./utils";

let version = Date.now();
let userData;

function processData(data) {
    userData = {
        runnerSite: data.parent_site,
        profileSite: data.user_site,
        user: data.user,
        sites: data.sites,
        menu: data.menu,
    };
    return userData;
}

export default function extendContextForLoggedInUser(refresh) {
    if (!refresh && userData) {
        return Promise.resolve(userData);
    }

    version = Date.now();
    return retrieveJsonRequest(`/core/users/light_settings.js?v=${version}`).then(processData);
}
